/*
 * NYORD: Bewegung auf der Startseite mit Motion (assets/motion-nyord.min.js, window.NyordMotion).
 * Ruhig und langsam auslaufend, eine Kurve für alles. Nur opacity und transform. Bei „Bewegung reduzieren“
 * passiert nichts. Versteckt wird nur, was beim Laden unterhalb des Bildschirms liegt: kein Aufblitzen, ohne JS
 * bleibt alles sichtbar.
 *
 * - Hero-Einstieg: reines CSS (nb-startseite.css, „Hero-Einstieg“), damit nichts vorher aufblitzt.
 * - Überschriften (.nb-titel, .nb-band__titel): Wort für Wort aus der Maske, sobald sie ins Bild kommen.
 * - [data-nb-einblenden]: Gruppe (oder mit ="kinder" ihre Kinder nacheinander) blendet von unten ein.
 * - Bilder in Kacheln, Vergleich, Spotlight, Story und Markengeschichte setzen sich beim Einblenden (1,12 auf 1).
 * - Video-Bühne: Karten liegen zuerst gestapelt in der Mitte und fächern sich auf.
 * Parallaxe von Hero- und Zwischenvideo macht reines CSS (scroll-driven animations, nb-startseite.css).
 */
(function () {
  var M = window.NyordMotion;
  if (!M || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var animate = M.animate;
  var inView = M.inView;
  var stagger = M.stagger;
  var EASE = [0.16, 1, 0.3, 1];
  var EASE_BILD = [0.22, 1, 0.36, 1];
  var WORT_AUS = 'translateY(115%)';

  function liste(l) {
    return Array.prototype.slice.call(l);
  }
  function unterhalb(el) {
    return el.getBoundingClientRect().top > window.innerHeight * 0.92;
  }
  function aufraeumen(teile) {
    teile.forEach(function (t) {
      t.style.opacity = '';
      t.style.transform = '';
    });
  }
  function maske(kind) {
    var m = document.createElement('span');
    m.className = 'nb-wort';
    m.appendChild(kind);
    return m;
  }
  // Überschrift in Wörter mit Maske zerlegen. <br> bleibt, andere Elemente (z. B. <em>) zählen als ein Wort.
  function woerter(el) {
    var innen = [];
    liste(el.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (stueck) {
          if (!stueck) return;
          if (/^\s+$/.test(stueck)) {
            frag.appendChild(document.createTextNode(stueck));
            return;
          }
          var wort = document.createElement('span');
          wort.textContent = stueck;
          frag.appendChild(maske(wort));
          innen.push(wort);
        });
        el.replaceChild(frag, n);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') {
        var platz = document.createElement('span');
        el.replaceChild(platz, n);
        platz.replaceWith(maske(n));
        innen.push(n);
      }
    });
    return innen;
  }

  // Überschriften weiter unten
  liste(document.querySelectorAll('.nb-titel, .nb-band__titel')).forEach(function (titel) {
    if (!unterhalb(titel)) return;
    var w = woerter(titel);
    w.forEach(function (s) {
      s.style.transform = WORT_AUS;
    });
    inView(
      titel,
      function () {
        animate(w, { transform: [WORT_AUS, 'none'] }, { duration: 1.0, delay: stagger(0.05), ease: EASE }).then(function () {
          aufraeumen(w);
        });
      },
      { amount: 0.5 }
    );
  });

  // Gruppen
  liste(document.querySelectorAll('[data-nb-einblenden]')).forEach(function (gruppe) {
    if (!unterhalb(gruppe)) return;
    var teile = gruppe.getAttribute('data-nb-einblenden') === 'kinder' ? liste(gruppe.children) : [gruppe];
    teile.forEach(function (t) {
      t.style.opacity = '0';
      t.style.transform = 'translateY(24px)';
    });
    inView(
      gruppe,
      function () {
        animate(
          teile,
          { opacity: [0, 1], transform: ['translateY(24px)', 'none'] },
          { duration: 0.9, delay: stagger(0.08), ease: EASE }
        ).then(function () {
          aufraeumen(teile);
        });
      },
      { amount: 0.15 }
    );
  });

  // Bilder setzen sich
  var BILDER = '.nb-kachel img, .nb-vergleich__bild img, .nb-spot__bild:not(.nb-spot__bild--video) img, .nb-story__karte img, .nb-marke__bild img';
  liste(document.querySelectorAll(BILDER)).forEach(function (bild) {
    if (!unterhalb(bild)) return;
    bild.style.transform = 'scale(1.12)';
    inView(
      bild.parentElement,
      function () {
        animate(bild, { transform: ['scale(1.12)', 'none'] }, { duration: 1.8, ease: EASE_BILD }).then(function () {
          bild.style.transform = '';
        });
      },
      { amount: 0.2 }
    );
  });

  // Video-Bühne fächert sich auf (Übergang in CSS, Dauer hier kurz verlängert)
  liste(document.querySelectorAll('.nb-buehne')).forEach(function (buehne) {
    if (!unterhalb(buehne)) return;
    buehne.setAttribute('data-zu', '');
    inView(
      buehne,
      function () {
        buehne.style.setProperty('--nb-dauer', '1.3s');
        setTimeout(function () {
          buehne.removeAttribute('data-zu');
        }, 150);
        setTimeout(function () {
          buehne.style.removeProperty('--nb-dauer');
        }, 1600);
      },
      { amount: 0.35 }
    );
  });
})();
